import "../styles/Hero.css";
import heroImage from "../images/Hero-image.png";

export default function Hero() {
  return (
    <section
      className="hero"
      style={{
        backgroundImage: `
          linear-gradient(
            to right,
            rgba(1, 18, 56, 0.95) 0%,
            rgba(1, 64, 164, 0.7) 40%,
            rgba(1, 64, 164, 0.2) 70%,
            rgba(1, 64, 164, 0) 100%
          ),
          url(${heroImage})
        `
      }}
    >
      <div className="container hero-content">

        <span className="badge">
          ⚙ PRECISION MANUFACTURING PARTNER
        </span>

        <h1>
          Precision AC <br />
          Manufacturing & <br />
          <span className="highlight">OEM Job Work</span> <br />
          Partner
        </h1>

        <p>
          Trusted manufacturing partner for leading global brands including Voltas, Hyundai, and Kenstar.<br></br>Since 2015, delivering excellence in AC 
          assembly and manufacturing.
        </p>

      </div>
    </section>
  );
}